module.exports = __webpack_public_path__ + "media/src/images/invoice-01-d85f463db3caf7e3333fb56cc252dbac.png";